// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type { CastReceiverOptions } from 'chromecast-caf-receiver/cast.framework';
import { CAST_MESSAGES } from '../../config/receiver';
import cast from '../../types/chromecast-caf-receiver/index';
import { isDev } from '../../utils/env';

import { appOptionsFilter } from '../extensions';

export class AppOptionsPlugin {
  init() {
    appOptionsFilter.register(this.appOptionsTransform.bind(this));
  }

  async appOptionsTransform(appOptions: CastReceiverOptions) {
    /**
     * Text that represents the application status. It should meet internationalization
     * rules as it may be displayed by the sender application.
     * @type {string|undefined}
     */
    appOptions.statusText = 'TV 2 PLAY';

    // 4.3.8 needed to suppport HDR playback
    appOptions.shakaVersion = '4.3.8';

    /**
     * Indicate the receiver should not load the MPL player.
     */
    appOptions.skipMplLoad = true;

    appOptions.customNamespaces = {
      [CAST_MESSAGES.ERROR]: cast.framework.system.MessageType.JSON,
    };

    if (isDev) {
      /**
       * Set custom namespaces for communication between sender and receiver.
       * @type {object|undefined}
       */
      appOptions.customNamespaces = {
        [CAST_MESSAGES.CONSOLE]: cast.framework.system.MessageType.JSON,
        [CAST_MESSAGES.ERROR]: cast.framework.system.MessageType.JSON,
        [CAST_MESSAGES.CUSTOM]: cast.framework.system.MessageType.JSON,
        [CAST_MESSAGES.REDIRECT]: cast.framework.system.MessageType.JSON,
        [CAST_MESSAGES.VCR]: cast.framework.system.MessageType.JSON,
      };

      /**
       * Maximum time in seconds before closing an idle
       * sender connection. Setting this value enables a heartbeat message to keep
       * the connection alive. Used to detect unresponsive senders faster than
       * typical TCP timeouts. The minimum value is 5 seconds, there is no upper
       * bound enforced but practically it's minutes before platform TCP timeouts
       * come into play. Default value is 10 seconds.
       * @type {number|undefined}
       */
      appOptions.maxInactivity = 60000;
    }
    return appOptions;
  }
}
